import { useFeatureFlags } from 'api';

export const useVariablePricingEnabled = () => {
  const flags = useFeatureFlags();
  return flags.getFlag('VARIABLE_PRICING_PO_SO_FORMS', true);
};
